<div class="p-grid grid">
  <div class="p-col-12 p-lg-6" style="margin: 0 auto;margin-bottom: 30px;">
    <div class="p-grid">
      <div class="p-col-12 welcomeTitle">
        {{ 'Factory of the Year Competition Title' | translate:{ year: surveyYear } }}
      </div>

      <div fxLayout="row" fxLayoutAlign="space-evenly center" class="button-container">
        <div class="p-col-12" style="margin-bottom: 50px">
          <div class="nextButtonWrapper">
            <button pButton class="button" label="{{ 'Introduction' | translate }}" [routerLink]="['/legal']"></button>
          </div>
        </div>

        <div class="p-col-12" style="margin-bottom: 50px">
          <div class="nextButtonWrapper">
            <button pButton class="button" label="{{ 'Questionnaire' | translate }}" (click)="buttonStartClicked()"></button>
          </div>
        </div>
      </div>
      <div style="text-align: left;" innerHTML="{{ 'Intro text' | translate }}">
    </div>
  </div>
</div>
